<div class="sp-mb-48">
  <h4 class="sp-mb-16">Basic Skeleton Example</h4>
  <ui-skeleton></ui-skeleton>
</div>
<div class="sp-mb-48">
  <h4 class="sp-mb-16">Skeleton with Avatar and Paragraph Example</h4>
  <ui-skeleton [uiAvatar]="true" [uiParagraph]="{ rows: 3 }"></ui-skeleton>
</div>
<div class="sp-mb-48">
  <h4 class="sp-mb-16">Animated Skeleton Example</h4>
  <ui-skeleton [uiActive]="true"></ui-skeleton>
</div>
